<template>
  <div class="formation-page">
    <div class="container formation-page__container">
      <section class="formation-page__shell">
        <section class="formation-hero">
          <div class="formation-hero__media">
            <img
              src="@/assets/pictures/formation-taxi-initiale.webp"
              alt="road-timelaps-night"
              loading="lazy"
            />
          </div>

          <div class="formation-hero__content">
            <OrderLesson
              lesson="Formation Taxi Initiale"
              :inline-in-parent="true"
            />

            <p class="formation-hero__eyebrow">Carte professionnelle taxi</p>
            <h1>TAXI INITIALE</h1>

            <div class="formation-hero__stats">
              <div class="formation-hero__stat">
                <span>Prix</span>
                <strong>1350€</strong>
              </div>
              <div class="formation-hero__stat">
                <span>Durée</span>
                <strong>Selon formule</strong>
              </div>
              <div class="formation-hero__stat">
                <span>Voiture de prêt</span>
                <strong>pour l'examen</strong>
              </div>
              <div class="formation-hero__stat">
                <span>Financement</span>
                <strong>Eligible CPF</strong>
              </div>
              <div class="formation-hero__stat">
                <span>paiement</span>
                <strong>3x sans frais</strong>
              </div>
            </div>
          </div>
        </section>

        <section class="formation-main">
          <div class="formation-page__back-row">
            <button
              name="button"
              @click="circleBtn('formation-taxi')"
              class="formation-page__back"
            >
              <span>&#171;</span> Retour formations
            </button>
          </div>

          <article class="formation-section formation-section--intro">
            <h2>Formation taxi initiale</h2>
            <p>
              La <strong>formation initiale</strong> pour
              <strong>devenir chauffeur de taxi</strong> est une étape
              essentielle pour acquérir les compétences nécessaires à cette
              profession et obtenir la
              <strong>carte professionnelle taxi</strong>. Elle se déroule sur
              une durée de 90 heures réparties sur 3 semaines. Les cours ont
              lieu de 9h30 à 12h30 et de 13h30 à 16h30, avec la possibilité de
              suivre des cours accélérés en soirée de 18h à 21h et même le
              weekend. Cette <strong>formation</strong>, d'un coût de 1350€, est
              éligible au Compte Personnel de Formation (CPF) et offre également
              la possibilité de paiement en 3 fois sans frais. Durant la
              formation, une voiture est mise à disposition pour l'examen
              pratique, et en cas d'échec à l'<strong>examen théorique</strong>,
              une deuxième chance est accordée. Les
              <strong>épreuves théoriques</strong> comprennent des connaissances
              sur la réglementation, la gestion, la sécurité routière, ainsi que
              des capacités d'expression et de compréhension en français et en
              anglais.
            </p>

            <div class="formation-certification">
              <p class="formation-certification__copy">
                <strong>certification:</strong> RS5635 Habilitation pour l'accès
                à la profession de conducteur de taxi.<br />
                <strong>certificateur:</strong>
                MINISTÈRE DE LA TRANSITION ECOLOGIQUE, DE LA BIODIVERSITÉ, DE LA
                FÔRET, DE LA MER ET DE LA PECHE.<br />
                <strong>date d'enregistrement:</strong>
                09-12-2021
              </p>
              <a
                href="https://www.francecompetences.fr/recherche/rs/5635/"
                class="formation-certification__link"
              >
                FRANCE compétences certification
              </a>
            </div>
          </article>

          <section class="formation-exams">
            <article class="formation-section formation-section--theory">
              <h2>Épreuves théoriques taxi</h2>

              <div class="formation-panel">
                <h3>5 épreuves théoriques "Tronc commun"</h3>

                <ul class="formation-list">
                  <li>
                    A – Réglementation du
                    <strong>transport public particulier de personnes</strong>
                    (coeff 3, note éliminatoire inférieure à 6/20)
                  </li>
                  <li>
                    B – Gestion (coeff 2, note éliminatoire inférieure à 6/20)
                  </li>
                  <li>
                    C - Sécurité routière (coeff 3, note éliminatoire inférieure
                    à 6/20)
                  </li>
                  <li>
                    D – Capacité d'expression et de compréhension en langue
                    française, sur la base d'un texte de 15 à 20 lignes (coeff
                    2, note éliminatoire inférieure à 6/20)
                  </li>
                  <li>
                    E – Capacité d'expression et de compréhension en langue
                    anglaise (coeff 1, note éliminatoire inférieure à 4/20)
                  </li>
                </ul>

                <h4>2 épreuves spécifiques d'admissibilité</h4>

                <ul class="formation-list">
                  <li>
                    F(T) Connaissance du territoire et la réglementation locale
                    (coeff 3, note éliminatoire inférieure à 6/20)
                  </li>
                  <li>
                    G(T) Réglementation nationale de l'activité taxis ainsi que
                    sur la gestion propre à l'activité (coeff 3, note
                    éliminatoire inférieure à 6/20)
                  </li>
                </ul>

                <div class="formation-panel__footer">
                  <p>Méthode d'évaluation : QCM et QRC</p>
                  <p>
                    Seuil d'admissibilité : 10 / 20 (sans note éliminatoire)
                  </p>
                  <p>
                    Validité de 1 an pour 3 présentations à l'examen pratique.
                  </p>
                </div>
              </div>
            </article>

            <div class="formation-exams__stack">
              <article class="formation-section formation-section--practice">
                <h2>Examen pratique taxi</h2>

                <div class="formation-panel">
                  <h3>Épreuves pratiques d'admission</h3>

                  <ul class="formation-list">
                    <li>
                      OBJECTIF : évaluer la capacité du candidat à assurer, par
                      sa conduite en circulation, la sécurité des passagers et
                      des autres usagers de la route tout en proposant aux
                      clients un service commercial de qualité.
                    </li>
                    <li>
                      Mise en situation pratique de réalisation d'une course de
                      taxi.
                    </li>
                  </ul>

                  <ul class="formation-list formation-list--compact">
                    <li>
                      Seuil d'admission à l'examen : 12 / 20 à l'<strong
                        >épreuve pratique</strong
                      >.
                    </li>
                  </ul>
                </div>
              </article>

              <ExamPrerequisitesCard mode="taxi" />
            </div>
          </section>

          <article class="formation-section formation-section--t3p">
            <h2>Examen t3p taxi</h2>
            <p>
              L'<strong>examen T3P</strong> (<strong
                >Transport Public Particulier de Personnes</strong
              >) est une étape clé pour obtenir la
              <strong>carte professionnelle de chauffeur de taxi</strong>. Les
              <strong>épreuves théoriques</strong> d'admissibilité évaluent les
              connaissances du candidat dans différents domaines tels que la
              réglementation, la gestion, la sécurité routière et les langues.
              La réussite à ces épreuves nécessite d'obtenir une note supérieure
              ou égale à 10/20, sans note éliminatoire. Une fois l'admissibilité
              obtenue, le candidat passe à l'épreuve pratique d'admission qui
              évalue sa capacité à assurer la sécurité des passagers et des
              autres usagers de la route tout en offrant un service commercial
              de qualité. Pour réussir cette épreuve, le seuil d'admission est
              fixé à 12/20. Il est important de se préparer rigoureusement pour
              l'<strong>examen T3P</strong> afin de pouvoir
              <strong>exercer la profession de chauffeur de taxi</strong>
              de manière compétente et responsable.
            </p>
          </article>
        </section>
      </section>
    </div>

    <div class="hrFooter"></div>
  </div>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import OrderLesson from "@/components/plugins/OrderLesson.vue";
import { useMeta } from "vue-meta";

export default {
  name: "TaxiInitiale",
  components: { ExamPrerequisitesCard, OrderLesson },
  setup() {
    useMeta({
      title: "Devenir chauffeur Taxi",
      description: [
        {
          content:
            "Découvrez notre formation initiale Taxi complète pour devenir un chauffeur de taxi professionnel qualifié. Apprenez les compétences essentielles en matière de réglementation, de sécurité routière, de gestion et de service client.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-taxi-initiale",
        },
      ],
    });
  },
  methods: {
    circleBtn(itemActif) {
      this.$router.push({
        path: "/formations-taxi-vtc",
        query: { itemActif: itemActif },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.formation-page {
  padding-top: clamp(90px, 11vw, 132px);
}

.formation-page__container {
  padding-inline: clamp(14px, 3vw, 28px);
}

.formation-page__shell {
  width: min(100%, 1240px);
  margin: 0 auto;
}

.formation-page__back {
  width: fit-content;
  border: 0;
  padding: 0;
  background: transparent;
  color: rgba(0, 42, 84, 0.76);
  font-family: "adam";
  font-size: 0.68rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  transition: color 0.2s ease, transform 0.2s ease;

  span {
    margin-right: 8px;
    color: $color-secondary;
    font-size: 0.96rem;
  }

  &:hover {
    transform: translateX(-2px);
    color: $color-primary;

    span {
      color: $color-secondary;
    }
  }
}

.formation-page__back-row {
  display: flex;
  justify-content: flex-start;
  margin: -4px 0 2px;
}

.formation-hero {
  display: grid;
  gap: 0;
  overflow: hidden;
  border-radius: 34px;
  background: #ffffff;
  box-shadow: 0 24px 44px rgba(0, 42, 84, 0.12);

  @media screen and (min-width: 992px) {
    grid-template-columns: minmax(0, 1.08fr) minmax(360px, 0.92fr);
    min-height: 470px;
  }
}

.formation-hero__media {
  position: relative;
  min-height: 260px;
  background: $color-primary;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.formation-hero__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  padding: clamp(16px, 2.6vw, 26px) clamp(24px, 4vw, 42px)
    clamp(24px, 4vw, 42px);
  background: $color-primary;
  color: $color-text-light;
}

.formation-hero__eyebrow {
  margin: 0;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: $color-secondary;
}

.formation-hero__content h1 {
  margin: 0;
  font-family: "quantum";
  font-size: clamp(2rem, 3.8vw, 3rem);
  letter-spacing: 0.08em;
  line-height: 0.98;
  color: $color-text-light;
}

.formation-hero__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.formation-hero__stat {
  min-height: 88px;
  padding: 14px 14px 16px;
  border-radius: 22px;
  border: 1px solid rgba(254, 185, 20, 0.16);
  background: rgba(0, 0, 0, 0.24);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;

  span {
    display: block;
    font-family: "adam";
    font-size: 0.62rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(254, 185, 20, 0.86);
  }

  strong {
    display: block;
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 0.94rem;
    line-height: 1.16;
    color: $color-text-light;
  }
}

.formation-main {
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-top: 30px;
}

.formation-section {
  border-radius: 30px;
  padding: clamp(22px, 4vw, 36px);
  background: #ffffff;
  box-shadow: 0 18px 36px rgba(0, 42, 84, 0.08);

  h2 {
    margin: 0 0 20px;
    color: $color-primary;
    font-size: clamp(1.45rem, 2.5vw, 2rem);
    text-align: left;
  }

  h3,
  h4,
  h5 {
    color: $color-primary;
    text-align: left;
  }

  p {
    margin: 0;
    color: $color-text;
    font-size: 1rem;
    line-height: 1.82;
  }
}

.formation-section--intro,
.formation-section--t3p {
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 8px;
    background: $color-secondary;
  }
}

.formation-certification {
  margin-top: 24px;
  padding: 20px 22px;
  border-radius: 24px;
  background: $color-primary;
  box-shadow: 0 16px 28px rgba(0, 42, 84, 0.18);
}

.formation-certification__copy {
  color: $color-text-light !important;

  strong {
    color: $color-secondary;
    font-weight: 700;
  }
}

.formation-certification__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 10px 16px;
  border-radius: 999px;
  background: $color-secondary;
  color: $color-primary;
  font-family: "adam";
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-decoration: none;
  box-shadow: 0 8px 16px rgba(254, 185, 20, 0.18);
}

.formation-exams {
  display: grid;
  gap: 24px;

  @media screen and (min-width: 992px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}

.formation-exams__stack {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.formation-section--theory {
  border-top: 8px solid $color-primary;
}

.formation-section--practice {
  border-top: 8px solid $color-secondary;
}

.formation-panel {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.formation-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  li {
    position: relative;
    padding: 16px 18px 16px 42px;
    border-radius: 22px;
    background: rgba(0, 42, 84, 0.04);
    color: $color-text;
    line-height: 1.62;
    box-shadow: inset 0 0 0 1px rgba(0, 42, 84, 0.08);

    &::before {
      content: "";
      position: absolute;
      top: 24px;
      left: 18px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: $color-secondary;
      box-shadow: 0 0 0 6px rgba(254, 185, 20, 0.12);
    }
  }
}

.formation-list--compact {
  margin-top: 4px;
}

.formation-panel__footer {
  margin-top: 4px;
  padding: 18px 20px;
  border-radius: 22px;
  background: $color-primary;
  box-shadow: 0 14px 28px rgba(0, 42, 84, 0.16);

  p {
    color: $color-text-light;
    line-height: 1.7;
  }

  p + p {
    margin-top: 8px;
  }
}

.hrFooter {
  width: min(100%, 980px);
  height: 1px;
  background-color: rgba(0, 42, 84, 0.16);
  margin: 34px auto 100px;
}

@media screen and (max-width: 767px) {
  .formation-page {
    padding-top: 20px;
  }

  .formation-hero {
    border-radius: 26px;
  }

  .formation-hero__stats {
    grid-template-columns: 1fr;
  }

  .formation-hero__stat {
    min-height: auto;
  }

  .formation-section {
    border-radius: 24px;
  }

  .formation-list li {
    padding-left: 38px;
  }
}
</style>
